import { render, staticRenderFns } from "./transportBinllingList.vue?vue&type=template&id=052c2758&scoped=true&"
import script from "./transportBinllingList.vue?vue&type=script&lang=tsx&"
export * from "./transportBinllingList.vue?vue&type=script&lang=tsx&"
import style0 from "./transportBinllingList.vue?vue&type=style&index=0&id=052c2758&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052c2758",
  null
  
)

export default component.exports